import { ActionToast, Toast, type ToastComponent } from '@opallabs/lapidary'

type CreatedToastProps = {
  /** Clears the filters that may be hiding what was just made. */
  onClearFilters?: () => void
  title: string
}

/**
 * Says what was made. When filters are on, the new item may not be anywhere a
 * person can see it, so the toast says so and offers the way out.
 */
export const CreatedToast: ToastComponent<CreatedToastProps> = ({
  onClearFilters,
  title,
  ...toastProps
}) =>
  onClearFilters ? (
    <ActionToast
      {...toastProps}
      actionText="Clear filters"
      actionType="secondary"
      message={`"${title}" was created. Your filters may be hiding it.`}
      title="Created"
      onActionClick={onClearFilters}
    />
  ) : (
    <Toast
      {...toastProps}
      message={`"${title}" was created.`}
      title="Created"
    />
  )
CreatedToast.displayName = 'Calendar: CreatedToast'
